import React from 'react';
import { View } from 'react-native';

import { scale } from '@components/frame';

import { font as initialFont } from '@styles/fonts';
import { isPhone, isWeb } from '@helpers';
import NcFileContent from '@components/common/NCFile';

export default (props) => {
  const { C, selectedItem, font = initialFont, lg } = props;
  const s = scale;
  const wrapperConfig = {};

  if (!isWeb) {
    wrapperConfig.flex = 1;
  }
  return (
    <View style={{ flex: 1, width: '100%' }}>
      <View
        {...{
          style: {
            width: '100%',
            flex: 1,
            customPosition: 'relative',
            borderRadius: s(isPhone ? 0 : 12),
            backgroundColor: C('Background/Light/Detail'),
          },
        }}
      >
        <View
          style={[
            {
              minWidth: '100%',
              width: '100%',
              flex: 1,
            },
          ]}
        >
          <NcFileContent
            {...{
              selectedItem,
              C,
              font,
              lg,
              backgroundColor: C('Background/Light/Field'),
              baseColor: C.scheme === 'dark' ? '0, 0, 0' : '243, 242, 248',
            }}
          />
        </View>
      </View>
    </View>
  );
};
